import * as path from "path";

import { pathExists, readJson, remove, rename } from "fs-extra";

import { ConsoleApplicationContext } from "../../Commons/ConsoleApplication/ConsoleApplicationContext";
import { FormGlobs } from "../../Commons/FormGlobsUtils";
import { ILogger } from "../../Commons/Logging/ILogger";

import { RenameFilesOptions } from "./RenameFilesOptions";

export async function runRenameFiles(
    context: ConsoleApplicationContext,
    options: RenameFilesOptions,
    farmDirectory: string
): Promise<void> {
    const formGlobs = await FormGlobs.resolveSpecifiers(options.formGlobs, farmDirectory);
    for (const { gfv, formPath } of await FormGlobs.resolveGfvGlobs(formGlobs, farmDirectory)) {
        if (!isNaN(Number(gfv))) {
            const logger = context.logger.withPrefix(`FORM:${gfv}`);
            await renameFiles(gfv, formPath, logger);
        }
    }
}

async function renameFiles(gfv: string, formPath: string, logger: ILogger): Promise<void> {
    const presentationsFile = path.join(formPath, "presentations.json");
    if (!(await pathExists(presentationsFile))) {
        logger.warning(`Form ${gfv} does not have presentations.json.`);
        return;
    }
    const json = await readJson(presentationsFile);
    let maxSubversion = 0;
    for (const item of json) {
        if (item["MaxVersion"] !== undefined && item["MaxVersion"]) {
            maxSubversion = item["MaxVersion"];
        }
    }
    maxSubversion = maxSubversion ?? 0;
    const rngXmlFileName = `${gfv}.rng.xml`;
    const newRngXmlFileName = `${gfv}.${maxSubversion}.rng.xml`;
    const fileDirPath = path.join(formPath, "schemas", rngXmlFileName);
    await remove(presentationsFile);
    if (!(await pathExists(fileDirPath))) {
        logger.warning(`Form ${gfv} does not have ${rngXmlFileName}.`);
        return;
    }
    const newFileDirPath = path.join(formPath, "schemas", newRngXmlFileName);
    logger.log(`Rename "${rngXmlFileName}" in "${newRngXmlFileName}".`);
    await rename(fileDirPath, newFileDirPath);
}
